import React, { Component, Fragment } from 'react';
import "../../../../../assets/Conversation.css";
import MessageBubble from './MessageBubble';
import Dropzone from 'react-dropzone';
import styles from '../../../../../assets/Conversation.module.css';
import {
    Row,
    Modal,
    ModalHeader,
    ModalBody,
    Card,
    CardBody,
} from 'reactstrap';
import TwilioConversationMessages from "./TwilioConversationMessages";
import { Button, Form, Input } from "antd";
import { CloseOutlined, EnterOutlined } from '@ant-design/icons';
import PropTypes from "prop-types";

class TwilioConversation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newMessage: '',
            conversationProxy: props.conversationProxy,
            messages: [],
            loadingState: 'initializing',
            boundConversations: new Set()
        };
    }

    loadMessagesFor = (thisConversation) => {
        if (this.state.conversationProxy === thisConversation) {
            thisConversation.getMessages()
                .then(messagePaginator => {
                    if (this.state.conversationProxy === thisConversation) {
                        this.setState({ messages: messagePaginator.items, loadingState: 'ready' });
                    }
                })
                .catch(err => {
                    console.error("Couldn't fetch messages IMPLEMENT RETRY", err);
                    this.setState({ loadingState: "failed" });
                });
        }
    };

    componentDidMount = () => {
        if (this.state.conversationProxy) {
            this.loadMessagesFor(this.state.conversationProxy);

            if (!this.state.boundConversations.has(this.state.conversationProxy)) {
                let newConversation = this.state.conversationProxy;
                newConversation.on('messageAdded', m => this.messageAdded(m, newConversation));
                this.setState({ boundConversations: new Set([...this.state.boundConversations, newConversation]) });
            }
        }
    }

    componentDidUpdate = (oldProps, oldState) => {
        if (this.state.conversationProxy !== oldState.conversationProxy) {
            this.loadMessagesFor(this.state.conversationProxy);

            if (!this.state.boundConversations.has(this.state.conversationProxy)) {
                let newConversation = this.state.conversationProxy;
                newConversation.on('messageAdded', m => this.messageAdded(m, newConversation));
                this.setState({ boundConversations: new Set([...this.state.boundConversations, newConversation]) });
            }
        }
    };

    static getDerivedStateFromProps(newProps, oldState) {
        let logic = (oldState.loadingState === 'initializing') || oldState.conversationProxy !== newProps.conversationProxy;
        if (logic) {
            return { loadingState: 'loading messages', conversationProxy: newProps.conversationProxy };
        } else {
            return null;
        }
    }

    messageAdded = (message, targetConversation) => {
        if (targetConversation === this.state.conversationProxy)
            this.setState((prevState, props) => ({
                messages: [...prevState.messages, message]
            }));
    };

    onMessageChanged = event => {
        this.setState({ newMessage: event.target.value });
    };

    sendMessage = () => {
        const message = this.state.newMessage;
        this.setState({ newMessage: '' });
        this.state.conversationProxy.sendMessage(message);
    };

    render = () => {
        return (
            <Fragment>
                <div style={{ flexBasis: "100%", flexGrow: 2, flexShrink: 1, overflowY: "scroll" }}>

                    <CloseOutlined
                        title='Clicking on this will close the conversation with user permanently. This action cannot be undone.'
                        style={{ fontSize: "1.5em", cursor: 'pointer', position: 'absolute', marginLeft: '20px', marginTop: '13px' }}
                        onClick={event => this.props.closeConversation(this.props.conversationProxy, event)}
                    />

                    <TwilioConversationMessages
                        identity={this.props.myIdentity}
                        messages={this.state.messages} />
                </div>
                <div>
                    <Form>
                        <Input.Group compact={true} style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row"
                        }}>
                            <Input
                                style={{ flexBasis: "100%" }}
                                placeholder={"Type your message here..."}
                                type={"text"}
                                name={"message"}
                                id={styles['type-a-message']}
                                autoComplete={"off"}
                                disabled={this.state.loadingState !== 'ready'}
                                onChange={this.onMessageChanged}
                                value={this.state.newMessage}
                                onPressEnter={this.sendMessage}
                            />
                            <Button
                                icon={<EnterOutlined />}
                                htmlType="button"
                                onClick={this.sendMessage}
                                type="button"
                            />
                        </Input.Group>
                    </Form>
                </div>
            </Fragment>
        );
    }
}

TwilioConversation.propTypes = {
    myIdentity: PropTypes.string.isRequired
};

export default TwilioConversation;
